module.exports = __webpack_public_path__ + "img/collection_icon_no.afd8c5de.svg";